import { render, staticRenderFns } from "./InventoryQuery.vue?vue&type=template&id=9d5fce48"
import script from "./InventoryQuery.vue?vue&type=script&lang=js"
export * from "./InventoryQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports